import React from "react";

export const PAGE_NOT_FOUND = {
  statusCode: "404",
  statusLabel: "Page Not Found",
  heading: "Oops, no Spikes here!",
  lead: "We couldn't find what you were looking for. Head home or reach out to support and we'll point you in the right direction.",
  suggestedFix: "Check the URL for typos, or navigate home to find what you need.",
  terminalCode: "server.response = 404_NOT_FOUND",
  terminalNote: "All other routes are online. This path does not exist.",
  showRetry: false,
}

export const NO_INTERNET_CONNECTION = {
  statusCode: "503",
  statusLabel: "Internet Connection Lost",
  heading: "No connection here.",
  lead: "We're experiencing connectivity issues. Check your network, hit retry, or try again in a moment.",
  suggestedFix: "Check your internet connection and refresh the page.",
  terminalCode: "server.response = 503_SERVICE_UNAVAILABLE",
  terminalNote: "The platform is ready. The connection could not be established.",
  showRetry: true,
}

export const SERVER_ERROR = {
  statusCode: "505",
  statusLabel: "HTTP Version Not Supported",
  heading: "The market is open. This connection isn't.",
  lead: "Your browser isn't compatible. Please update it, refresh the page, or contact support if the issue persists.",
  suggestedFix: "Refresh, update your browser, or bypass an incompatible proxy/VPN.",
  terminalCode: "server.response = 505_HTTP_VERSION_NOT_SUPPORTED",
  terminalNote: "Supported routes are online. This request needs a compatible HTTP version.",
  showRetry: true,
}

export const SYSTEM_UPDATE = {
  statusCode: "503",
  statusLabel: "System Update",
  heading: "We'll be right back.",
  lead: "Spiking is currently undergoing a scheduled update. We'll be back online shortly — check back soon.",
  suggestedFix: "Wait a few minutes and refresh. No action needed on your end.",
  terminalCode: "server.response = 503_MAINTENANCE",
  terminalNote: "Scheduled maintenance in progress. The platform will return shortly.",
  showRetry: false,
}
